export default Object.freeze({
  GET_PROJECT_PROFILE: "GET_PROJECT_PROFILE"
});
